module.exports = __webpack_public_path__ + "img/7_178.3935ce0b.png";